// Create a new component file: AdminRemarksDialog.js
import React, { useEffect, useRef, useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, DialogActions,
    Typography, Box, TextareaAutosize, Button, IconButton
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const AdminRemarksDialog = ({
    open,
    onClose,
    record,
    status,
    type,
    onSubmit
}) => {
    const [adminRemarksInput, setAdminRemarksInput] = useState('');
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (open && record) {
            setAdminRemarksInput(record.adminRemarks || '');
            setError('');
        }
    }, [open, record]);

    const handleSubmit = async () => {
        setSubmitting(true);
        setError('');
        try {
            const schoolid = localStorage.getItem('schoolid') || sessionStorage.getItem('schoolid');
            if (!schoolid) throw new Error('Login information not found.');

            const response = await fetch('https://chat.visualbench.com/updateRecord', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    type,
                    selectedid: record?.id,
                    status,
                    adminremarks: adminRemarksInput
                })
            });

            const result = await response.json();

            if (!response.ok) throw new Error(result.error || 'Failed to update record.');

            onSubmit(record?.id, status, adminRemarksInput);
            onClose();

        } catch (err) {
            console.error(err);
            setError(err.message || 'An unexpected error occurred.');
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                Enter Admin Remarks
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent>
                {record && (
                    <Box sx={{ mb: 2 }}>
                        {[
                            ['Name', record.name],
                            ['Contact', record.contact],
                            ['Email', record.email],
                            [type === 'enquiry' ? 'User Remarks' : 'Feedback', record.remarks],
                            ...(type === 'enquiry' ? [['Stream', record.stream]] : []),
                            ['Created Date', record.date],
                            ...(record.adminupdate
                                ? [[
                                    'Updated Date',
                                    new Date(record.adminupdate).toLocaleString('en-GB', {
                                        day: '2-digit',
                                        month: 'short',
                                        year: 'numeric',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                        hour12: true,
                                    }).replace(',', '')
                                ]]
                                : [])
                        ].map(([label, value], index) => (
                            <Box key={index} sx={{ display: 'flex', mb: 0.5 }}>
                                <Typography sx={{ fontWeight: 'bold', minWidth: '140px' }}>{label}:</Typography>
                                <Typography>{value}</Typography>
                            </Box>
                        ))}
                    </Box>
                )}
                <TextareaAutosize
                    minRows={4}
                    value={adminRemarksInput}
                    onChange={(e) => setAdminRemarksInput(e.target.value)}
                    placeholder="Type remarks here..."
                    style={{ width: '100%', marginTop: '10px', padding: '10px', fontSize: '16px' }}
                />
                {error && <Typography sx={{ color: 'red', mt: 1 }}>{error}</Typography>}
            </DialogContent>
            <DialogActions sx={{ pr: 3, pb: 2 }}>
                <Button variant="contained" onClick={handleSubmit} disabled={submitting}>
                    {submitting ? 'Submitting...' : 'Submit'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AdminRemarksDialog;
